import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/ChatOnboarding/Steps/DiagnosisUnlockFlow/mapPresentRiskToDiagnosisUnlockView";
/**
 * `present_risk_and_goals` payload → 弹窗 Step2 / Step3 视图数据。
 *
 * 对齐 changes-summary.md：
 * - `riskSummary` → Step2 单句 headline
 * - `riskItems[].riskLevel` → finding severity
 * - `goalDraft` → Step3 Plan 预览
 */

import type { DiagnosisFindingItem } from "@/src/components/DiagnosisFindingsPanel";
import type {
  DiagnosisUnlockDiagnosisView,
  DiagnosisUnlockGoalDraft,
  DiagnosisUnlockModalPayload,
  DiagnosisUnlockPlanPayload,
  DiagnosisUnlockRiskItem,
} from "./types";

const I18n = I18nUtil.createScoped(Translations);

const GOAL_CARD_BACKGROUND_SRC =
  "/assets/chat/save-goal-card/goal-card-v3-bg-sm-v2.webp";

const RISK_LEVEL_TO_SEVERITY: Record<
  DiagnosisUnlockRiskItem["riskLevel"],
  DiagnosisFindingItem["severity"]
> = {
  high: "critical",
  medium: "important",
  low: "minor",
};

const SEVERITY_LABEL: Record<DiagnosisFindingItem["severity"], string> = {
  critical: I18n.t("Critical issue"),
  important: I18n.t("Important issue"),
  minor: I18n.t("Minor issue"),
};

/** 单条 RiskItem → DiagnosisFindingItem（severityLabel 本期固定英文三档） */
export function mapRiskItemToFinding(
  item: DiagnosisUnlockRiskItem,
  index: number,
): DiagnosisFindingItem {
  const severity = RISK_LEVEL_TO_SEVERITY[item.riskLevel];
  return {
    id: `risk-${index}-${item.riskLevel}`,
    severity,
    severityLabel: SEVERITY_LABEL[severity],
    title: item.title,
    description: item.description,
  };
}

export function mapRiskItemsToFindings(
  items: DiagnosisUnlockRiskItem[],
): DiagnosisFindingItem[] {
  return items.map(mapRiskItemToFinding);
}

/** payload → Step2 视图 */
export function mapPayloadToDiagnosisView(
  payload: DiagnosisUnlockModalPayload,
): DiagnosisUnlockDiagnosisView {
  return {
    riskSummary: payload.riskSummary,
    findings: mapRiskItemsToFindings(payload.riskItems),
  };
}

/** goalDraft → Step3 Plan 预览 */
export function mapGoalDraftToPlanPayload(
  goalDraft: DiagnosisUnlockGoalDraft,
): DiagnosisUnlockPlanPayload {
  return {
    goalTitle: goalDraft.title,
    goalBackgroundSrc: GOAL_CARD_BACKGROUND_SRC,
    actionSummary: goalDraft.summary,
    trackerSpecs: goalDraft.trackerSpecs,
  };
}
